import { Field, FieldInputProps, FieldMetaProps, useField } from "formik";
import DatePicker from "react-datepicker";

interface IProps {
  label: string;
  name: string;
  containerClassName?: string;
  type?: string;
  showSqFt?: boolean;
}

export const FormikInput = ({
  label,
  name,
  containerClassName = "",
  type = "text",
  showSqFt = false,
}: IProps) => {
  const [field, meta, helpers] = useField(name);

  return (
    <div className={containerClassName}>
      <label className="text-sm font-medium text-gray-700" htmlFor={name}>
        {label}
      </label>
      <Field name={name}>
        {({
          field,
          meta,
        }: {
          field: FieldInputProps<any>;
          meta: FieldMetaProps<any>;
        }) => (
          <div>
            {type === "date" ? (
              <DatePicker
                className="border px-4 py-2 outline-none w-full"
                selected={(field.value && new Date(field.value)) || null}
                onChange={(date) => helpers.setValue(date)}
                dateFormat="yyyy-MM-dd"
              />
            ) : (
              <div className="relative">
                <input
                  className="border px-4 py-2 outline-none w-full"
                  type={type}
                  id={name}
                  {...field}
                />
                {showSqFt ? (
                  <span className="font-medium text-sm absolute top-3 right-4 inline-block text-gray-400">
                    sq.ft
                  </span>
                ) : null}
              </div>
            )}
            {meta.touched && meta.error && (
              <div className="text-xs text-red-500 mt-2">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
    </div>
  );
};
